export default __webpack_public_path__ + "static/big_square_shadow_kviff-9da4a6e92bbd032c712be1f0e4528be9.gif";